var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "watermark-container" },
    _vm._l(_vm.watermarks, function (n) {
      return _c("div", { key: n, staticClass: "watermark" }, [
        _c("div", [
          _vm._v("\n      " + _vm._s(_vm.userInfo.user_name) + "\n    "),
        ]),
        _c("div", [
          _vm._v("\n      " + _vm._s(_vm.userInfo.user_id) + "\n    "),
        ]),
      ])
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }